const normalizeScopePath = (path: string): string =>
  path.endsWith('/') ? path : `${path}/`

export const isCatalogRequestScopeActive = (
  routePath: string,
  scopePath: string | null,
): boolean => {
  if (!scopePath) {
    return true
  }

  const normalizedScopePath = normalizeScopePath(scopePath)
  return (
    routePath === normalizedScopePath.slice(0, -1) ||
    routePath.startsWith(normalizedScopePath)
  )
}
